<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>
        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />

        <action-button type="delete" @click="del(moduletemplate.id)" v-if="moduletemplate.id && $can('moduletemplate-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md3 sm6 xs12 class="d-none">
                <v-select
                  name="moduletemplate.template_type"
                  v-model="moduletemplate.template_type"
                  item-text="text"
                  item-value="key"
                  :items="dd_moduletemplate_template_type"
                  :label="$t('moduletemplates.template_type')"
                  :error-messages="errors.collect('moduletemplate.template_type')"
                  @change="templateTypeChange(false)"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-autocomplete
                  name="moduletemplate.coursetypegroup_id"
                  v-model="moduletemplate.coursetypegroup_id"
                  :items="coursetypegroups"
                  item-text="name"
                  item-value="id"
                  :label="$t('moduletemplates.coursetypegroup_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('moduletemplate.coursetypegroup_id')"
                  @change="courseTypeGroupChange(moduletemplate.coursetypegroup_id)"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-autocomplete
                  name="moduletemplate.coursetype_id"
                  v-model="moduletemplate.coursetype_id"
                  :items="coursetypes"
                  item-text="name"
                  item-value="id"
                  :label="$t('moduletemplates.coursetype_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('moduletemplate.coursetype_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg4 md3 sm6 xs12>
                <v-text-field
                  name="moduletemplate.name"
                  v-model="moduletemplate.name"
                  class="required-field"
                  v-validate="'required|max:100'"
                  :label="$t('moduletemplates.name')"
                  :error-messages="errors.collect('moduletemplate.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12>
                <v-select
                  name="moduletemplate.status"
                  v-model="moduletemplate.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_module_templates_status()"
                  :label="$t('moduletemplates.status')"
                  :error-messages="errors.collect('moduletemplate.status')"
                  clearable
                ></v-select>
              </v-flex>

              <v-flex xs12>
                <v-textarea
                  name="moduletemplate.description"
                  v-model="moduletemplate.description"
                  :label="$t('moduletemplates.description')"
                  :error-messages="errors.collect('moduletemplate.description')"
                ></v-textarea>
              </v-flex>

              <v-flex lg3 md3 sm6 xs12>
                <v-checkbox
                  name="moduletemplate.hide_in_accomplishment"
                  v-model="moduletemplate.hide_in_accomplishment"
                  :label="$t('moduletemplates.hide_in_accomplishment')"
                  :error-messages="errors.collect('moduletemplate.hide_in_accomplishment')"
                  @change="changeHideInAccomplishment()"
                >
                  <template slot="label">
                    {{ $t("moduletemplates.hide_in_accomplishment") }}
                    <span class="ml-1"><help-text slot="append" :tooltip="$t('moduletemplates.hide_in_accomplishment_helptext')" /></span>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-checkbox
                  name="moduletemplate.hide_in_enrolment"
                  v-model="moduletemplate.hide_in_enrolment"
                  :label="$t('moduletemplates.hide_in_enrolment')"
                  :error-messages="errors.collect('moduletemplate.hide_in_enrolment')"
                  @change="changeHideInEnrolment()"
                ></v-checkbox>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-select
                  name="moduletemplate.select_visibility"
                  v-model="moduletemplate.select_visibility"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_select_visibility()"
                  :label="$t('moduletemplates.select_visibility')"
                  :error-messages="errors.collect('moduletemplate.select_visibility')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-autocomplete
                  name="moduletemplate.req_coursetemplate_id"
                  v-model="moduletemplate.req_coursetemplate_id"
                  :items="coursetemplates"
                  item-text="name"
                  item-value="id"
                  :label="$t('moduletemplates.req_coursetemplate_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('moduletemplate.req_coursetemplate_id')"
                  clearable
                >
                  <help-text slot="append-outer" :tooltip="$t('moduletemplates.required_module_course_helptext')" />
                </v-autocomplete>
              </v-flex>
              <v-flex lg4 md3 sm6 xs12>
                <v-autocomplete
                  name="moduletemplate.req_module_id"
                  v-model="moduletemplate.req_module_id"
                  :items="moduletemplates"
                  item-text="name"
                  item-value="id"
                  :label="$t('moduletemplates.req_module_id')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('moduletemplate.req_module_id')"
                  clearable
                >
                  <help-text slot="append-outer" :tooltip="$t('moduletemplates.required_module_course_helptext')" />
                </v-autocomplete>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12 v-if="course_type == 1 || course_type == null">
                <v-checkbox
                  name="moduletemplate.is_included"
                  v-model="moduletemplate.is_included"
                  :label="$t('moduletemplates.is_included')"
                  :error-messages="errors.collect('moduletemplate.is_included')"
                ></v-checkbox>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12 v-if="!moduletemplate.is_included && (course_type == 1 || course_type == null)">
                <v-text-field
                  name="moduletemplate.price"
                  v-model="computedPrice"
                  @keypress="$keyDown_PriceOnly($event)"
                  :hint="'Format:' + PRICE_FORMAT"
                  :label="$t('moduletemplates.price')"
                  :error-messages="errors.collect('moduletemplate.price')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12 v-if="!moduletemplate.is_included && (course_type == 1 || course_type == null)">
                <v-text-field
                  name="moduletemplate.price_vat"
                  v-model="computedPriceVat"
                  @keypress="$keyDown_PriceOnly($event)"
                  :hint="'Format:' + PRICE_FORMAT"
                  :label="$t('moduletemplates.price_vat')"
                  :error-messages="errors.collect('moduletemplate.price_vat')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="moduletemplate.req_hours"
                  v-model="moduletemplate.req_hours"
                  v-validate="'decimal'"
                  :label="$t('moduletemplates.req_hours')"
                  :error-messages="errors.collect('moduletemplate.req_hours')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12 v-if="false">
                <v-select
                  name="moduletemplate.type"
                  v-model="moduletemplate.type"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_moduletemplate_type()"
                  :label="$t('moduletemplates.type')"
                  :error-messages="errors.collect('moduletemplate.type')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg4 md4 sm4 xs12>
                <v-text-field
                  name="moduletemplate.internal_note"
                  v-model="moduletemplate.internal_note"
                  v-validate="'max:25'"
                  :label="$t('moduletemplates.internal_note')"
                  :error-messages="errors.collect('moduletemplate.internal_note')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12 v-if="false">
                <v-checkbox
                  name="moduletemplate.is_joint"
                  v-model="moduletemplate.is_joint"
                  :label="$t('moduletemplates.is_joint')"
                  :error-messages="errors.collect('moduletemplate.is_joint')"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 v-if="moduletemplate.updated_by != null">
                <p class="text-right mb-0">
                  {{
                    $t("global.last_updated_by") +
                    (moduletemplate.updated_by == -1 ? $t("global.xl3_admin") : moduletemplate.updated_by_name)
                  }}
                  {{ moment.utc(moduletemplate.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CourseModuleTemplateForm",

  props: ["id", "modal", "course_id", "course_type", "manually_added", "had_accomplishment_completed"],

  data() {
    return {
      dd_moduletemplate_template_type: this.$dd_moduletemplate_template_type(),

      page_title: "",
      predata: {},
      moduletemplate: {},
      moduletemplates: [],
      coursetemplates: [],
      coursetypegroups: [],
      coursetypes: [],
      dictionary: {
        attributes: {
          "moduletemplate.name": this.$t("moduletemplates.name"),
          "moduletemplate.description": this.$t("moduletemplates.description"),
          "moduletemplate.coursetemplate_id": this.$t("coursetemplates.title"),
          "moduletemplate.req_hours": this.$t("moduletemplates.req_hours"),
          "moduletemplate.req_module_id": this.$t("moduletemplates.req_module_id"),
          "moduletemplate.req_coursetemplate_id": this.$t("moduletemplates.req_coursetemplate_id"),
          "moduletemplate.type": this.$t("moduletemplates.type"),
          "moduletemplate.template_type": this.$t("moduletemplates.template_type"),
          "moduletemplate.price": this.$t("moduletemplates.price"),
          "moduletemplate.price_vat": this.$t("moduletemplates.price_vat"),
          "moduletemplate.status": this.$t("moduletemplates.status"),
          "moduletemplate.is_joint": this.$t("moduletemplates.is_joint"),
          "moduletemplate.is_included": this.$t("moduletemplates.is_included"),
          "moduletemplate.internal_note": this.$t("moduletemplates.internal_note"),
          "moduletemplate.hide_in_accomplishment": this.$t("moduletemplates.hide_in_accomplishment"),
          "moduletemplate.hide_in_enrolment": this.$t("moduletemplates.hide_in_enrolment"),
          "moduletemplate.select_visibility": this.$t("moduletemplates.select_visibility")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.moduletemplate, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedPrice: {
      get() {
        return this.$priceFormatGetter(this.moduletemplate.price)
      },
      set(val) {
        this.$set(this.moduletemplate, "price", this.$priceFormatSetter(val))
      }
    },
    computedPriceVat: {
      get() {
        return this.$priceFormatGetter(this.moduletemplate.price_vat)
      },
      set(val) {
        this.$set(this.moduletemplate, "price_vat", this.$priceFormatSetter(val))
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      let lists = [
        { key: "moduletemplates", module: "moduletemplates", query: "show_all=true" },
        { key: "coursetemplates", module: "coursetemplates", query: "show_all=true" },
        { key: "coursetypegroups", module: "coursetypegroups", query: "show_all=true" }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.coursetypegroups = res.data.coursetypegroups
        this.coursetemplates = res.data.coursetemplates
        this.moduletemplates = res.data.moduletemplates.filter((item) => item.id != this.id)

        if (!this.id) {
          this.moduletemplate = {}

          this.moduletemplate = {
            status: this.$getDefaultDropdown(this.$dd_module_templates_status()),
            mandatory: 1,
            course_id: this.course_id || null
          }

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.moduletemplate))

          this.setPageTitle()
        } else {
          this.title = this.$t("moduletemplates.update_title")

          axios
            .get(this.API_URL + "coursemoduletemplate/" + this.id)
            .then((res) => {
              this.moduletemplate = res.data.data

              // JSON stringify and parse to remove variable reactiveness
              this.predata = JSON.parse(JSON.stringify(this.moduletemplate))
              this.setPageTitle()
              this.templateTypeChange(true)
              this.courseTypeGroupChange(this.moduletemplate.coursetypegroup_id)
            })
            .catch((err) => console.log(err))
        }
      })
    },
    setPageTitle() {
      if (_.has(this.moduletemplate, "id")) {
        this.page_title = this.$t("moduletemplates.edit_moduletemplate", {
          name: this.moduletemplate.name
        })
      } else {
        this.page_title = this.$t("moduletemplates.new_moduletemplate")
      }
    },
    templateTypeChange(firstLoad = false) {
      axios.get(this.API_URL + "coursetypegroups?show_all=true").then((res) => {
        this.coursetypegroups = res.data.data

        this.coursetypes = []

        if (!firstLoad) {
          this.moduletemplate.coursetype_id = null
        }
      })
    },
    courseTypeGroupChange(groupId) {
      axios.get(this.API_URL + "coursetypes?show_all=true&query_coursetypegroup_id=" + groupId).then((res) => {
        this.coursetypes = res.data.data
      })
    },
    changeHideInAccomplishment() {
      if (this.moduletemplate.hide_in_accomplishment) {
        this.moduletemplate.hide_in_enrolment = 0
      }
    },
    changeHideInEnrolment() {
      if (this.moduletemplate.hide_in_enrolment) {
        this.moduletemplate.hide_in_accomplishment = 0
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.moduletemplate.id) {
              // Create
              if (this.had_accomplishment_completed && this.moduletemplate.mandatory) {
                this.$awn.confirm(
                  this.$t("attendees.accomplishment_mandatory_addedupdated_confirm"),
                  () => {
                    this.createRecord(true)
                  },
                  () => {
                    this.$emit("return_modal_cancel_form")
                  },
                  {
                    labels: {
                      confirm: this.$t("global.confirm_message"),
                      confirmOk: this.$t("global.yes"),
                      confirmCancel: this.$t("global.no")
                    }
                  }
                )
              } else {
                this.createRecord(false)
              }
            } else {
              // Update
              if (this.had_accomplishment_completed && !this.predata.mandatory && this.moduletemplate.mandatory) {
                this.$awn.confirm(
                  this.$t("attendees.accomplishment_mandatory_addedupdated_confirm"),
                  () => {
                    this.updateRecord(true)
                  },
                  () => {
                    this.$emit("return_modal_cancel_form")
                  },
                  {
                    labels: {
                      confirm: this.$t("global.confirm_message"),
                      confirmOk: this.$t("global.yes"),
                      confirmCancel: this.$t("global.no")
                    }
                  }
                )
              } else {
                this.updateRecord(false)
              }
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    createRecord(updateaccomplishment = false) {
      let vm = this
      let user = this.$store.getters["auth/user"]

      axios
        .post(this.API_URL + "coursemoduletemplate", {
          admin_id: this.moduletemplate.admin_id,
          course_id: this.moduletemplate.course_id,
          name: this.moduletemplate.name,
          description: this.moduletemplate.description,
          req_hours: this.moduletemplate.req_hours,
          req_coursetemplate_id: this.moduletemplate.req_coursetemplate_id,
          req_module_id: this.moduletemplate.req_module_id,
          coursetypegroup_id: this.moduletemplate.coursetypegroup_id || null,
          coursetype_id: this.moduletemplate.coursetype_id || null,
          type: this.moduletemplate.type,
          template_type: this.moduletemplate.template_type,
          price: this.moduletemplate.price,
          price_vat: this.moduletemplate.price_vat,
          status: this.moduletemplate.status,
          is_included: this.moduletemplate.is_included,
          is_joint: this.moduletemplate.is_joint,
          select_visibility: this.moduletemplate.select_visibility,
          hide_in_accomplishment: this.moduletemplate.hide_in_accomplishment,
          hide_in_enrolment: this.moduletemplate.hide_in_enrolment,
          internal_note: this.moduletemplate.internal_note,
          mandatory: this.moduletemplate.mandatory,
          manually_added: this.manually_added,
          created_by: user.id
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            if (res.data.data.id) {
              vm.moduletemplate = res.data.data
              vm.predata = JSON.parse(JSON.stringify(vm.moduletemplate))

              if (!updateaccomplishment) {
                vm.$awn.success(vm.$t("global.create_success"))
              }

              if (vm.modal) {
                vm.$emit("return_modal_form", {
                  module: "coursemoduletemplate",
                  mode: "add",
                  data: res.data.data,
                  updateaccomplishment: updateaccomplishment
                })
              } else {
                vm.setPageTitle()
                vm.$router.replace(this.BACKEND_URL + `/moduletemplates/edit/${vm.moduletemplate.id}`).catch(() => {})
              }
            }
          }
        })
        .catch((err) => console.log(err))
    },
    updateRecord(updateaccomplishment = false) {
      let vm = this

      axios
        .put(this.API_URL + "coursemoduletemplate", {
          id: this.moduletemplate.id,
          admin_id: this.moduletemplate.admin_id,
          course_id: this.moduletemplate.course_id,
          name: this.moduletemplate.name,
          description: this.moduletemplate.description,
          req_hours: this.moduletemplate.req_hours,
          req_coursetemplate_id: null,
          req_module_id: this.moduletemplate.req_module_id,
          req_coursetemplate_id: this.moduletemplate.req_coursetemplate_id,
          coursetypegroup_id: this.moduletemplate.coursetypegroup_id || null,
          coursetype_id: this.moduletemplate.coursetype_id || null,
          type: this.moduletemplate.type,
          template_type: this.moduletemplate.template_type,
          price: this.moduletemplate.price,
          price_vat: this.moduletemplate.price_vat,
          status: this.moduletemplate.status,
          is_included: this.moduletemplate.is_included,
          is_joint: this.moduletemplate.is_joint,
          select_visibility: this.moduletemplate.select_visibility,
          hide_in_accomplishment: this.moduletemplate.hide_in_accomplishment,
          hide_in_enrolment: this.moduletemplate.hide_in_enrolment,
          internal_note: this.moduletemplate.internal_note,
          mandatory: this.moduletemplate.mandatory,
          manually_added: this.manually_added
        })
        .then((res) => {
          vm.moduletemplate = res.data.data
          vm.predata = JSON.parse(JSON.stringify(vm.moduletemplate))

          vm.setPageTitle()

          if (!updateaccomplishment) {
            vm.$awn.success(vm.$t("global.update_success"))
          }

          if (vm.modal) {
            vm.$emit("return_modal_form", {
              module: "coursemoduletemplate",
              mode: "edit",
              data: res.data.data,
              updateaccomplishment: updateaccomplishment
            })
          }
        })
        .catch((err) => console.log(err))
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursemoduletemplate/" + id)
            .then((res) => {
              if (this.modal) {
                vm.$emit("return_modal_form", {
                  module: "coursemoduletemplate",
                  mode: "delete"
                })
              } else {
                vm.$router.push(this.BACKEND_URL + "/moduletemplates")
              }
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style>
.form-modal {
  background: white;
}
.ct-td {
  padding: 9px !important;
  background: var(--v-secondary-base) !important;
}
.tr-no-bottom-border td {
  border-bottom: 0 !important;
}
.mandatory-chkbox {
  margin-top: 18px !important;
  margin-right: 30px !important;
}
.mandatory-chkbox .v-input__slot {
  margin-bottom: 0 !important;
}
.mandatory-chkbox.v-input--checkbox .v-label {
  color: #fff !important;
}
</style>
